module.exports = __webpack_public_path__ + "static/media/Rules and Regulations.a188a91e.pdf";